module.exports = __webpack_public_path__ + "static/media/vender.a6095bd9.svg";